module.exports = __webpack_public_path__ + "img/nochoose.f50ed024.svg";